<ng-container *ngIf="twoFactorSetup$ | async; else loading; let twoFactorSetup">
  <nb-card nbSpinnerStatus="primary" class="card-box">
    <nb-card-header class="content-header">
      <nb-icon class="icon" icon="shield-outline" status="basic"></nb-icon>
      <span class="header"
        >{{ "common.two-factor-authentication" | translate }}
      </span>
      <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>

    <nb-card-body class="qr-modal__body">
      <h3 class="qr-modal__title">{{ "user.two-factor.qr-title" | translate }}</h3>
      <p class="qr-modal__description">
        {{ "user.two-factor.qr-description" | translate }}
      </p>

      <div class="qr-modal__qr">
        <qr-code
          [value]="twoFactorSetup.authenticatorUri"
          size="180"
          errorCorrectionLevel="M"
        ></qr-code>
      </div>

      <div class="qr-modal__manual">
        <p class="qr-modal__description">
          {{ "user.two-factor.qr-manual-description" | translate }}
        </p>

        <div class="qr-modal__code-wrapper cursor-pointer" 
        cdkCopyToClipboard="{{ twoFactorSetup.key }}"
        (click)="copyCode()"
        aria-label="Copy code"
        aria-hidden="true"
        click-stop-propagation>
          <span class="qr-modal__code">
            <span *ngFor="let group of getCodeGroups(twoFactorSetup.key)">
              {{ group }}
            </span>
          </span>

          <nb-icon
            icon="copy-outline"
            nbTooltip="{{ 'common.copy' | translate }}"
          ></nb-icon>
        </div>
      </div>

      <div class="qr-modal__verify">
        <h4 class="qr-modal__subtitle"> {{ "common.verify" | translate }}</h4>
        <p class="qr-modal__description">
          {{ "user.two-factor.qr-verify-description" | translate }}
        </p>
        
        <input
          nbInput
          fullWidth
          type="text"
          maxlength="6"
          placeholder="Authentication Code"
          [(ngModel)]="authCode"
          (ngModelChange)="onCodeChange($event)"
          [status]="error ? 'danger' : 'basic'"
          (keypress)="allowOnlyDigits($event)"
          (paste)="handlePaste($event)"
          class="qr-modal__input"
        />
        <span *ngIf="error" class="qr-modal__error">
          {{ error }}
        </span>
      </div>
    </nb-card-body>

    <nb-card-footer class="content-footer">
      <button
        nbButton
        [status]="'primary'"
        [size]="'large'"
        tabindex="-1"
        [disabled]="!isCodeValid || isLoading"
        [nbSpinner]="isLoading"
        nbSpinnerStatus="primary"
        (click)="verifyCode()"
      >
        {{ "common.verify" | translate }}
      </button>
      <button
        nbButton
        [size]="'large'"
        [status]="'control'"
        [appearance]="'outline'"
        (click)="cancel()"
        tabindex="-1"
      >
        {{ "common.cancel" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-container>
<ng-template #loading>
  <div class="spinner" [nbSpinner]="true" nbSpinnerSize="large"></div>
</ng-template>
